<!-- 垂直分页 -->
<template>
  <div class="vertical-pagination">
    <div class="vertical-pagination__wrap" ref="wrap">
      <div class="vertical-pagination__container">
        <div
          class="slide-item"
          v-for="(item, index) in data"
          :key="item.ID"
          :class="{
            active: activeIndex === index,
            'image-radius': themeStyle.type === 'circle'
          }"
          :disabled="activeIndex === index"
          @click="() => handleClick(index)"
        >
          <i
            v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
            class="slide-item__video-icon"
            :class="{
              'el-icon-video-play': item.media_content_type === 'video',
              'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
            }"
          ></i>
          <v-lazy-img :src="item.thumbnail" :data-url="item.url" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
//import LazyImg from '../LazyImg.vue'

export default {
  // components: { LazyImg },
  props: {
    data: {
      type: Array,
      require: true,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  model: {
    prop: 'activeIndex',
    event: 'change',
  },
  emits: ['change'],
  mounted() {
    this.slideTo(this.activeIndex)
  },
  methods: {
    handleClick(index) {
      this.$emit('change', index)
    },
    slideTo(index) {
      const dom = this.$el.querySelectorAll('.slide-item')?.[index]
      const top = dom?.offsetTop || 0

      const wrap = this.$refs.wrap
      this.$(wrap)?.animate(
        {
          scrollTop: top,
        },
        200
      )
    },
  },
  computed: {
    ...mapState({
      themeStyle: ({ options }) => options?.theme?.global?.style || {},
    })
  },
  watch: {
    activeIndex(newVal, oldVal) {
      if (newVal !== oldVal) this.slideTo(newVal)
    },
  },
}
</script>
<style scoped lang='scss'>
.vertical-pagination {
  min-height: 500px;
  overflow: hidden;
  &__wrap {
    height: 100%;
    overflow-y: scroll;
    padding-right: 17px;
    margin-right: -17px;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  &__container {
    transition: all 0.5s;
    .slide-item {
      position: relative;
      margin-bottom: 20px;
      cursor: pointer;
      min-height: 30px;
      &__video-icon {
        position: absolute;
        z-index: 2;
        font-size: 30px;
        color: #fff;
        height: 100%;
        width: 100%;
        background: #00000035;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &::before {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        content: '';
        z-index: 2;
      }
      &.active {
        cursor: auto;
        &::before {
          border: 2px solid var(--main-btn-bg);
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .slideItem:last-child {
      margin-bottom: 0;
    }
  }
}
</style>